const getLocnIdfromH3Id = (h3CellString) => {
    const h3CellStringLast4 = h3CellString.substring(h3CellString.length - 4);
    const h3CellStringFirstPart = h3CellString.substring(0, h3CellString.length - 4);
    const locnIdFirstPart = parseInt(h3CellStringFirstPart,16).toString(36);
    const locnIdLast5 = parseInt(h3CellStringLast4,16).toString().padStart(5,0);
    return locnIdFirstPart + '-' + locnIdLast5;
}

const getH3IdfromLocnId = (locnIdString='3fzaq7y9g-19135') => {
    const [locnIdStringFirstPart, locnIdStringLastPart] = locnIdString.split('-');
    const h3CellIdFirstPart = parseInt(locnIdStringFirstPart,36).toString(16).padStart(11,0);
    const h3CellIdLastPart = parseInt(locnIdStringLastPart,10).toString(16).padStart(4,0);
    const h3CellId = h3CellIdFirstPart + h3CellIdLastPart;
    return h3CellId;
}

  export {getLocnIdfromH3Id, getH3IdfromLocnId}